export default __webpack_public_path__ + "static/media/graficos-05.80b694dd.png";